import * as React from 'react'

import { observer } from 'mobx-react'

import FormRow from 'modules/core/components/FormRow'
import Select from 'modules/core/components/Inputs/Select'
import i18n from 'modules/core/lib/i18n'

import { useGetFolders } from 'modules/documents/hooks/useGetFolders'
import { SPACES } from 'modules/documents/lib/constants'
import type ArgumentForm from 'modules/reports/components/Editor/Field/Options/Types/Filtering/ArgumentForm'

interface Props {
  forms: ArgumentForm[]
}

const DocumentCategorySelector = ({ forms }: Props) => {
  const { folders: unknownFolders, loading: unknownLoading } = useGetFolders({
    url: 'payment', // Payment is the slug so as to retrieve Others
    rootFolders: true,
    space: SPACES.UNKNOWN,
  })

  const { folders: employeeFolders, loading: employeeLoading } = useGetFolders({
    rootFolders: true,
    space: SPACES.EMPLOYEE_MY_DOCUMENTS,
  })

  const folderNamesLoaded = !employeeLoading && !unknownLoading
  const folderNames = [...unknownFolders, ...employeeFolders].map(({ name }) => ({
    value: name,
    label: name,
  }))

  const form = forms[0]

  return form && folderNamesLoaded ? (
    <FormRow>
      <Select
        none={i18n.t('custom_reports.especial_filters.document_type.none')}
        label={i18n.t('custom_reports.especial_filters.document_type.label')}
        field={form.get('value')}
        options={folderNames}
      />
    </FormRow>
  ) : null
}

export default observer(DocumentCategorySelector)
